import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { getHelmet } from "../utilities";
import { colors, FromTopPage, GridWrapper } from "../theme";
import Newsletter from "../components/Newsletter";
import bgMLetterBottom from "../assets/bg-mletter-header.png";
import bgMLetterTop from "../assets/bg-mletter-header-top.svg";

const Container = styled(FromTopPage)`
  background: url(${bgMLetterTop}) top right, url(${bgMLetterBottom});
  background-repeat: no-repeat;
  background-size: auto, 100% 315px;
  padding: 70px 0;
  text-align: center;

  @media (max-width: 1023px) {
    padding: 40px 0 70px;
  }

  @media (max-width: 767px) {
    padding: 30px 0 40px;
  }

  h1 {
    color: black;
    font-size: 4.8rem;
    font-weight: 100;
    letter-spacing: -0.07rem;
    line-height: 5.8rem;
    margin-bottom: 16px;
    text-transform: uppercase;

    @media (max-width: 1023px) {
      font-size: 3.8rem;
    }

    @media (max-width: 767px) {
      font-size: 2rem;
      line-height: 3.3rem;
    }

    strong {
      font-weight: 700;
      font-size: 6.4rem;
      display: block;

      @media (max-width: 1023px) {
        font-size: 5.4rem;
      }

      @media (max-width: 767px) {
        font-size: 2.9rem;
      }
    }
  }
`;

const Main = styled(GridWrapper)`
  background: linear-gradient(to right, #9164a0, #e51a6d 60%, #f75454);
  box-shadow: 8px 12px 20px rgba(46, 68, 82, 0.2);
  color: white;
  min-height: 224px;
  margin-top: 46px;
  max-width: 727px;
  padding: 38px 20px;

  @media (max-width: 1023px) {
    margin-top: 34px;
  }

  @media (max-width: 767px) {
    width: calc(100% - 40px);
  }

  h2 {
    font-size: 1.7rem;
    font-weight: 400;
    letter-spacing: 0.03rem;
    text-transform: uppercase;
  }

  form > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 23px auto 20px;
    width: 578px;

    @media (max-width: 1023px) {
      width: 478px;
    }

    @media (max-width: 767px) {
      display: block;
      width: 100%;
    }
  }

  input {
    border: 0;
    border-radius: 6px;
    color: ${colors.textColor};
    font-size: 1.9rem;
    height: 40px;
    padding: 0 16px;
    text-transform: lowercase;
    width: 382px;

    @media (max-width: 1023px) {
      width: 352px;
    }

    @media (max-width: 767px) {
      margin-bottom: 10px;
      text-align: center;
      width: 100%;
    }
  }

  button {
    background: ${colors.purple};
    color: white;
    font-weight: 600;
    height: 44px;
    text-transform: uppercase;
    transition: 0.3s;
    width: 182px;

    &:hover {
      background: ${colors.lightPurple};
    }

    @media (max-width: 1023px) {
      width: 112px;
    }

    @media (max-width: 767px) {
      width: 100%;
    }
  }

  form + p {
    font-size: 1.2rem;
    line-height: 1.8rem;
    margin: auto;
    width: 472px;

    @media (max-width: 767px) {
      width: 100%;
    }
  }

  p + p {
    display: none;
  }

  .already-subscribed {
    background: white;
    border-radius: 6px;
    color: ${colors.textColor};
    height: 40px;
    line-height: 40px;
    margin: 35px auto;
    width: 472px;

    i {
      margin-right: 6px;
    }
  }
`;

function Newsletters({ location }) {
  return (
    <Container>
      <Helmet>
        {getHelmet(
          "Les newsletters",
          "Inscrivez-vous aux newsletters du Média",
          location.pathname
        )}
      </Helmet>
      <h1>
        Inscrivez-vous à <strong>la newsletter du&nbsp;Média</strong>
      </h1>
      <Main>
        <h2>Recevoir la newsletter du&nbsp;Média</h2>
        <Newsletter />
        <p>
          Pour recevoir les dernières actualités, le résumé de la semaine et
          être alerté des derniers programmes publiés directement dans votre
          boîte e-mail.
        </p>
      </Main>
    </Container>
  );
}

Newsletters.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Newsletters;
